const NavBar = ({clinic}) => {
    return ( 
        <>
            <nav className="navbar bg-light p-4 mb-0">
                    <div className="container-fluid d-flex justify-content-around">
                        <div className="navbar-brand">
                            {clinic.logo?<div className='navbar-brand'>
                                <img src={clinic.logo} alt='practice logo' width='100%'/>
                            </div>:<h1></h1>}
                        </div>
                        <div className="d-flex flex-column">

                            <span className="display-6">{clinic.name}</span>
                         

                        </div>
                    </div>
                </nav>
                
        </>
     );
}
 
export default NavBar;